import { t } from 'ember-intl';
import { and, eq } from 'ember-truth-helpers';
import { variation } from 'ember-launch-darkly';
import { OperationRefreshRoute, LayoutSidebarSubnav } from 'core/components';
import { urlFor, resourceTypeFor, resourceIsBusy } from 'core/helpers';

<template>
  <OperationRefreshRoute
    @model={{@controller.model.dnsForwardingRulesFlatMap}}
    @route="cloud.orgs.detail.projects.detail.hvns.detail"
    @routeFallback={{urlFor "cloud.orgs.detail.projects.detail"}}
    @resourceType={{resourceTypeFor "network-dns-forwarding-rule"}}
  />

  <OperationRefreshRoute
    @model={{@controller.model.dnsForwardings}}
    @route="cloud.orgs.detail.projects.detail.hvns.detail"
    @routeFallback={{urlFor "cloud.orgs.detail.projects.detail"}}
    @resourceType={{resourceTypeFor "network-dns-forwarding"}}
  />

  <LayoutSidebarSubnav as |Subnav|>
    <Subnav.BackLink
      @text={{t
        "nav.back"
        resource=(t "components.page.hvns.list.title-short")
      }}
      @route="cloud.orgs.detail.projects.detail.hvns.list"
    />
    <Subnav.Title>
      {{@controller.model.network.id}}
    </Subnav.Title>
    <Subnav.Link
      @text={{t "components.page.hvns.detail.tabs.overview"}}
      @route="cloud.orgs.detail.projects.detail.hvns.detail.index"
      data-test-tabs-overview
    />
    {{#unless
      (resourceIsBusy
        @controller.model.network type=(resourceTypeFor "network")
      )
    }}
      {{#if
        (and
          (variation "hcp-hvn-guided-flow")
          (eq @controller.model.network.location.region.provider "aws")
        )
      }}
        <Subnav.Link
          @text={{t "components.page.hvns.detail.tabs.routes"}}
          @route="cloud.orgs.detail.projects.detail.hvns.detail.hvn-routes"
          @count={{@controller.model.routes.length}}
          data-test-tabs-routes
        />
        <Subnav.Link
          @text={{t "components.page.hvns.detail.tabs.connected-clusters"}}
          @route="cloud.orgs.detail.projects.detail.hvns.detail.connected-clusters.index"
          @count={{@controller.model.dependencies.length}}
          data-test-tabs-connected-clusters
        />
      {{else}}
        <Subnav.Link
          @text={{t "components.page.hvns.detail.tabs.peering-connections"}}
          @route="cloud.orgs.detail.projects.detail.hvns.detail.peerings"
          @count={{@controller.model.peerings.length}}
          data-test-tabs-peerings
        />
        {{#if (eq @controller.model.network.location.region.provider "aws")}}
          <Subnav.Link
            @text={{t
              "components.page.hvns.detail.tabs.transit-gateway-attachments"
            }}
            @route="cloud.orgs.detail.projects.detail.hvns.detail.transit-gateway-attachments"
            @count={{@controller.model.tgwAttachments.length}}
            data-test-tabs-transit-gateway-attachments
          />
        {{/if}}
        <Subnav.Link
          @text={{t "components.page.hvns.detail.tabs.routes"}}
          @route="cloud.orgs.detail.projects.detail.hvns.detail.hvn-routes"
          @count={{@controller.model.routes.length}}
          data-test-tabs-routes
        />
      {{/if}}
      {{#if
        (and
          (eq @controller.model.network.location.region.provider "aws")
          (variation "hcpv-byodns")
        )
      }}
        <Subnav.Link
          @text={{t "components.page.hvns.detail.tabs.custom-dns-forwarding"}}
          @route="cloud.orgs.detail.projects.detail.hvns.detail.dns-forwarding-rules"
          @count={{@controller.model.dnsForwardingRules.length}}
          data-test-tabs-forwarding
        />
      {{/if}}
    {{/unless}}
  </LayoutSidebarSubnav>

  {{outlet}}
</template>
